// Accent palettes the user can pick. Each id matches a :root[data-accent="…"]
// block in index.css that redefines --accent-50…950 (which indigo-* reads).

export const ACCENTS = [
  // Swatches are literal colours: bg-indigo-* now follows the chosen accent.
  { id: "indigo", labelKey: "settings.accents.indigo", swatch: "#4f46e5" },
  { id: "violet", labelKey: "settings.accents.violet", swatch: "#7c3aed" },
  { id: "blue", labelKey: "settings.accents.blue", swatch: "#2563eb" },
  { id: "cyan", labelKey: "settings.accents.cyan", swatch: "#0891b2" },
  { id: "teal", labelKey: "settings.accents.teal", swatch: "#0d9488" },
  { id: "pink", labelKey: "settings.accents.pink", swatch: "#db2777" },
  { id: "orange", labelKey: "settings.accents.orange", swatch: "#ea580c" },
] as const;

export type Accent = (typeof ACCENTS)[number]["id"];

export const DEFAULT_ACCENT: Accent = "indigo";

export const ACCENT_STORAGE_KEY = "accent";

export function isAccent(value: unknown): value is Accent {
  return ACCENTS.some((a) => a.id === value);
}

export function readStoredAccent(): Accent {
  try {
    const stored = localStorage.getItem(ACCENT_STORAGE_KEY);
    return isAccent(stored) ? stored : DEFAULT_ACCENT;
  } catch {
    return DEFAULT_ACCENT;
  }
}

export function applyAccent(accent: Accent) {
  document.documentElement.dataset.accent = accent;
}
